import { trackMediaQuery } from '@withease/web-api';
import { combine, createEvent } from 'effector';
import { useStoreMap } from 'effector-react';
import { Breakpoint, BREAKPOINTS } from 'shared/config';

const setup = createEvent();

const xs = trackMediaQuery(`(width > ${BREAKPOINTS.xs}px)`, { setup });

const sm = trackMediaQuery(`(width > ${BREAKPOINTS.sm}px)`, { setup });

const md = trackMediaQuery(`(width > ${BREAKPOINTS.md}px)`, { setup });

const lg = trackMediaQuery(`(width > ${BREAKPOINTS.lg}px)`, { setup });

const xl = trackMediaQuery(`(width > ${BREAKPOINTS.xl}px)`, { setup });

const xxl = trackMediaQuery(`(width > ${BREAKPOINTS.xxl}px)`, { setup });

const height = trackMediaQuery('(height > 800px)', { setup });

const $breakpoints = combine({
	xs: xs.$matches,
	sm: sm.$matches,
	md: md.$matches,
	lg: lg.$matches,
	xl: xl.$matches,
	xxl: xxl.$matches,
	height: height.$matches,
});

export const breakpoints = {
	setup,
	xs,
	sm,
	md,
	lg,
	xl,
	xxl,
	height,
};
export const useBreakpoint = (breakpoint: Breakpoint, withHeight = true) =>
	useStoreMap({
		store: $breakpoints,
		keys: [breakpoint],
		fn: (state, [bp]) => state[bp] && (withHeight ? state.height : true),
	});
